// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e760de5f","703":"305b5703","787":"b473f79a"}[chunkId] + ".chunk.js";
};